<template>
   <div>
      <div class="row mt-4" v-if="hasProducts ||hasGifts">
         <div class="col-lg-8">
            <div class="">
               <div class="cart-head">
                  <div class="table-responsive">
                     <table class="table">
                        <thead>
                           <tr>
                              <th scope="col">Producto</th>
                              <th scope="col">Piezas</th>
                              <th scope="col">Total</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="(p, idx) in selectedProducts" :key="`p_${idx}`">
                              <td>{{p.name}}</td>
                              <td>{{p.pieces}}</td>
                              <td>{{explicitMoneyFormat(p.total)}}</td>
                           </tr>
                           <tr v-for="(p, idx) in selectedGifts" :key="`g_${idx}`">
                              <td>{{p.name}} (regalo)</td>
                              <td>{{p.pieces}}</td>
                              <td>{{explicitMoneyFormat(p.total)}}</td>
                           </tr>
                            <tr>
                              <td colspan="2" class="text-right"><span class="midhigh-row-font">Subtotal</span></td>
                              <td><span class="midhigh-row-font">{{formattedSubtotal}}</span></td>
                           </tr>
                           <tr>
                              <td colspan="2" class="text-right"><span class="midhigh-row-font">Descuento</span></td>
                              <td><span class="midhigh-row-font">{{formattedDiscount}}</span></td>
                           </tr>
                           <tr>
                              <td colspan="2" class="text-right"><span class="high-row-font">TOTAL</span></td>
                              <td><span class="high-row-font">{{formattedTotal}}</span></td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </div>

   </div>
</template>


<script>
import {Promotion} from "@classes/promotion"
import formatHelper from "@mixins/formatHelper"
export default {
   name: "PromoProductsResume",
   mixins: [formatHelper],
   props: {
      promotion: { type: [Promotion, Object] },
      promoQuantity: { type: [String, Number], default: 1 },
      selectedProducts: {type: Array, default: []},
      selectedGifts: {type: Array, default: []},
      totalDiscount: { type: [String, Number], default: 0 }
   },
   mounted(){
   },
   data() {
      return {
      }
   },
   computed: {
      hasProducts() {
         return (this.selectedProducts && this.selectedProducts.length > 0)
      },
      totalPiecesProducts(){
         if(this.selectedProducts){
            let t = 0
            this.selectedProducts.forEach(f => { t += f.pieces })
            return t
         }
         return 0
      },
      hasGifts() {
         return (this.selectedGifts && this.selectedGifts.length > 0)
      },
      totalPiecesGifts(){
         if(this.selectedGifts){
            let t = 0
            this.selectedGifts.forEach(f => { t += f.pieces })
            return t
         }
         return 0
      },
      subtotal(){
         if(this.selectedProducts){
            let t = 0
            this.selectedProducts.forEach(f => { t += f.total })
            return t
         }
         return 0
      },
      total(){
         return this.subtotal - this.totalDiscount
      },
      formattedSubtotal(){
         return this.explicitMoneyFormat(this.subtotal)
      },
      formattedDiscount(){
         return this.explicitMoneyFormat(this.totalDiscount)
      },
      formattedTotal(){
         return this.explicitMoneyFormat(this.total)
      }
   },
}
</script>